import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Location from '../geom/Location';
import EdgeEnd from './EdgeEnd';
import Position from './Position';
import TopologyException from '../geom/TopologyException';
import Label from './Label';
var DirectedEdge = /*#__PURE__*/function (_EdgeEnd) {
  _inherits(DirectedEdge, _EdgeEnd);
  function DirectedEdge() {
    var _this;
    _classCallCheck(this, DirectedEdge);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirectedEdge).call(this));
    DirectedEdge.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(DirectedEdge, [{
    key: "getNextMin",
    value: function getNextMin() {
      return this._nextMin;
    }
  }, {
    key: "getDepth",
    value: function getDepth(position) {
      return this._depth[position];
    }
  }, {
    key: "setVisited",
    value: function setVisited(isVisited) {
      this._isVisited = isVisited;
    }
  }, {
    key: "computeDirectedLabel",
    value: function computeDirectedLabel() {
      this._label = new Label(this._edge.getLabel());
      if (!this._isForward) this._label.flip();
    }
  }, {
    key: "getNext",
    value: function getNext() {
      return this._next;
    }
  }, {
    key: "setDepth",
    value: function setDepth(position, depthVal) {
      if (this._depth[position] !== -999) if (this._depth[position] !== depthVal) throw new TopologyException('assigned depths do not match', this.getCoordinate());
      this._depth[position] = depthVal;
    }
  }, {
    key: "isInteriorAreaEdge",
    value: function isInteriorAreaEdge() {
      var isInteriorAreaEdge = true;
      for (var i = 0; i < 2; i++) if (!(this._label.isArea(i) && this._label.getLocation(i, Position.LEFT) === Location.INTERIOR && this._label.getLocation(i, Position.RIGHT) === Location.INTERIOR)) isInteriorAreaEdge = false;
      return isInteriorAreaEdge;
    }
  }, {
    key: "setNextMin",
    value: function setNextMin(nextMin) {
      this._nextMin = nextMin;
    }
  }, {
    key: "print",
    value: function print(out) {
      _get(_getPrototypeOf(DirectedEdge.prototype), "print", this).call(this, out);
      out.print(' ' + this._depth[Position.LEFT] + '/' + this._depth[Position.RIGHT]);
      out.print(' (' + this.getDepthDelta() + ')');
      if (this._isInResult) out.print(' inResult');
    }
  }, {
    key: "setMinEdgeRing",
    value: function setMinEdgeRing(minEdgeRing) {
      this._minEdgeRing = minEdgeRing;
    }
  }, {
    key: "isLineEdge",
    value: function isLineEdge() {
      var isLine = this._label.isLine(0) || this._label.isLine(1);
      var isExteriorIfArea0 = !this._label.isArea(0) || this._label.allPositionsEqual(0, Location.EXTERIOR);
      var isExteriorIfArea1 = !this._label.isArea(1) || this._label.allPositionsEqual(1, Location.EXTERIOR);
      return isLine && isExteriorIfArea0 && isExteriorIfArea1;
    }
  }, {
    key: "setEdgeRing",
    value: function setEdgeRing(edgeRing) {
      this._edgeRing = edgeRing;
    }
  }, {
    key: "getMinEdgeRing",
    value: function getMinEdgeRing() {
      return this._minEdgeRing;
    }
  }, {
    key: "getDepthDelta",
    value: function getDepthDelta() {
      var depthDelta = this._edge.getDepthDelta();
      if (!this._isForward) depthDelta = -depthDelta;
      return depthDelta;
    }
  }, {
    key: "setInResult",
    value: function setInResult(isInResult) {
      this._isInResult = isInResult;
    }
  }, {
    key: "getSym",
    value: function getSym() {
      return this._sym;
    }
  }, {
    key: "isForward",
    value: function isForward() {
      return this._isForward;
    }
  }, {
    key: "getEdge",
    value: function getEdge() {
      return this._edge;
    }
  }, {
    key: "printEdge",
    value: function printEdge(out) {
      this.print(out);
      out.print(' ');
      if (this._isForward) this._edge.print(out);else this._edge.printReverse(out);
    }
  }, {
    key: "setSym",
    value: function setSym(de) {
      this._sym = de;
    }
  }, {
    key: "setVisitedEdge",
    value: function setVisitedEdge(isVisited) {
      this.setVisited(isVisited);
      this._sym.setVisited(isVisited);
    }
  }, {
    key: "setEdgeDepths",
    value: function setEdgeDepths(position, depth) {
      var depthDelta = this.getEdge().getDepthDelta();
      if (!this._isForward) depthDelta = -depthDelta;
      var directionFactor = 1;
      if (position === Position.LEFT) directionFactor = -1;
      var oppositePos = Position.opposite(position);
      var delta = depthDelta * directionFactor;
      var oppositeDepth = depth + delta;
      this.setDepth(position, depth);
      this.setDepth(oppositePos, oppositeDepth);
    }
  }, {
    key: "getEdgeRing",
    value: function getEdgeRing() {
      return this._edgeRing;
    }
  }, {
    key: "isInResult",
    value: function isInResult() {
      return this._isInResult;
    }
  }, {
    key: "setNext",
    value: function setNext(next) {
      this._next = next;
    }
  }, {
    key: "isVisited",
    value: function isVisited() {
      return this._isVisited;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._isForward = null;
      this._isInResult = false;
      this._isVisited = false;
      this._sym = null;
      this._next = null;
      this._nextMin = null;
      this._edgeRing = null;
      this._minEdgeRing = null;
      this._depth = [0, -999, -999];
      var edge = arguments[0],
        isForward = arguments[1];
      EdgeEnd.constructor_.call(this, edge);
      this._isForward = isForward;
      if (isForward) {
        this.init(edge.getCoordinate(0), edge.getCoordinate(1));
      } else {
        var n = edge.getNumPoints() - 1;
        this.init(edge.getCoordinate(n), edge.getCoordinate(n - 1));
      }
      this.computeDirectedLabel();
    }
  }, {
    key: "depthFactor",
    value: function depthFactor(currLocation, nextLocation) {
      if (currLocation === Location.EXTERIOR && nextLocation === Location.INTERIOR) return 1;else if (currLocation === Location.INTERIOR && nextLocation === Location.EXTERIOR) return -1;
      return 0;
    }
  }]);
  return DirectedEdge;
}(EdgeEnd);
export { DirectedEdge as default };